import { ICellRendererParams } from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { Pricing } from "src/app/models/priceyard.model";

@Component({
  selector: "app-single-price-cell-renderer",
  templateUrl: "./single-price-cell-renderer.component.html",
  styleUrls: ["./single-price-cell-renderer.component.scss"],
})
export class SinglePriceCellRendererComponent implements OnDestroy {
  price: Pricing;
  constructor() {}
  params: ICellRendererParams;
  private destroy$ = new Subject<void>();

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const priceName = params["props"];
    this.price = {
      name: this.convertName(priceName),
      price:
        typeof params.data[priceName] === "object" &&
        params.data[priceName] !== null
          ? params.data[priceName].Price
          : params.data[priceName],
      isAuto:
        typeof params.data[priceName] === "object" &&
        params.data[priceName] !== null
          ? params.data[priceName].IsActive
          : undefined,
    };
  }

  convertName(name) {
    switch (name) {
      case "MapPrice":
        return "MAP";
      default:
        break;
    }
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
